import { render, staticRenderFns } from "./ModalQuestion.vue?vue&type=template&id=d593f5c2&scoped=true&"
import script from "./ModalQuestion.vue?vue&type=script&lang=js&"
export * from "./ModalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ModalQuestion.vue?vue&type=style&index=0&id=d593f5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d593f5c2",
  null
  
)

export default component.exports